import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.SUPER_ADMIN };
const path = "admin/support-chat";

export const listSessions = async () => {
    return await axiosInstance(options).get(`${path}/list-sessions`);
};

export const getMessages = async (sessionId) => {
    return await axiosInstance(options).get(`${path}/get-messages/${sessionId}`);
};

export const reply = async (values) => {
    return await axiosInstance(options).post(`${path}/reply`, values);
};

export const closeSession = async (sessionId) => {
    return await axiosInstance(options).patch(`${path}/close-session/${sessionId}`);
};

export const createOrGetSessionAdmin = async (data) => {
    return await axiosInstance(options).post(`${path}/create-session`, data);
};

export const getRelatedContext = async (params) => {
    return await axiosInstance(options).get(`${path}/related-context`, { params });
};
